export * from './modal-product-in-category.module'
export * from './modal-product-in-category.component'
